// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reload-button {\n    margin-right: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
